module.exports = __webpack_public_path__ + "static/media/end1.4ef832e0.wav";